// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about .menuList[data-v-cd2a4b94]{width:100%;margin:auto;display:flex;border-bottom:1px solid #ccc}.about .menuList .menuItem[data-v-cd2a4b94]{padding:10px 20px;cursor:pointer}.about .menuList .menuItem.active[data-v-cd2a4b94]{background:#01419a;color:#fff}", ""]);
// Exports
module.exports = exports;
